$('.contact-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    const form = this;
    form.reset();
    form.classList.remove('was-validated');
    $(form).find('[data-content-input]').trigger('input');

    $('#contactThankModal').modal('show');
});